export default __webpack_public_path__ + "static/1_31-ed56384bf6765fa769884992ac747142.png";